import { gql } from '@apollo/client';

export const GET_AGENCY = gql`
  query GetAgency($name: String!) {
    agency(name: $name) {
      id
      name
      logo
      description
      address
      phone
      email
      website
      facebook
      instagram
      tiktok
      firstTitle
      secondTitle
      imageCover
      theme {
        primaryColor
        secondaryColor
        accentColor
        textColor
        backgroundColor
        heroTextColor
        headerStyle
        font
      }
      popularDestinations {
        id
        name
        image
        price
      }
      aboutImage
      yearsExperience
      expertise
      satisfiedTravelers
      prestations
    }
  }
`; 